import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonMultipleFieldRequiredDirective } from './multiple-field-required.directive';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [
		FormsModule,
		CommonModule,
	],
	exports: [
		CommonMultipleFieldRequiredDirective,
	],
	declarations: [
		CommonMultipleFieldRequiredDirective,
	],
	entryComponents: [],
})
export class CommonMultipleFieldRequiredValidatorModule {}
